import React from "react";
import PropTypes from "prop-types";

import Badge from "components/Badge";
import {black500, greyishBlue600} from "assets/jss/main";

function parseVariant(value) {
    const s = String(value ?? "");
    const match = s.match(/^(.+?)(\s+x\d+)?$/);

    return { label: match?.[1] ?? s, multiplier: match?.[2] ?? "" };
}

function VariantBadge({ value }) {
    const { label, multiplier } = parseVariant(value);

    return (
        <Badge color="draft" size="small" isBold={false}>
            <b style={{ color: black500 }}>{label}</b>
            {multiplier && <span style={{ color: greyishBlue600 }}>{multiplier}</span>}
        </Badge>
    );
}

VariantBadge.propTypes = {
    value: PropTypes.string,
};

export default VariantBadge;
